// Shared Cloudinary URL helper — inserts a transformation right after
// "/upload/" so images are served resized/compressed instead of as full-res
// originals. Falls back to the original URL for non-Cloudinary sources.
export function cloudinaryUrl(url, transform) {
  if (!url || !url.includes('res.cloudinary.com') || !url.includes('/upload/')) return url
  const stripped = url.replace(/\/upload\/(?:[a-z]+_[^/]+\/)+/, '/upload/')
  return stripped.replace('/upload/', `/upload/${transform}/`)
}

export function thumbUrl(url) {
  return cloudinaryUrl(url, 'w_400,q_auto,f_auto')
}
